<template>
  <div id="app">
    <!-- /* indicator -->
    <div id="preloader" v-show="loading">
      <div data-loader="circle-side" v-show="loading"></div>
    </div>
    <router-view @show-loading="showLoading" @hide-loading="hideLoading"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    /**
     * ローディングインジケータ表示
     * 子のcomponentsから this.$emit('show-loading'); で呼び出す
     */
    showLoading() {
      this.loading = true;
    },
    /**
     * ローディングインジケータ非表示
     * 子のcomponentsから this.$emit('hide-loading'); で呼び出す
     */
    hideLoading() {
      this.loading = false;
    },
    /**
     * 前の画面に戻る
     * 子のcomponentsから this.$parent.backView(); で呼び出す
     */
    backView() {
      this.$store.commit('setIsBack', true);
      const prevPath = this.$store.getters.getPrevPath;
      this.$store.commit('shiftPath');
      this.$router.replace({
        path: prevPath,
      });
    },
  },
};
</script>

<style>
@import "./assets/css/custom.css";
@import "./assets/css/default.css";
</style>
